import React from 'react';
import { Button } from 'reactstrap';
import Modal from '../../../ui/Modal';

const blockEl = 'invoices__calendar-modal';

const RemoveAutoChargeModal = ({
  isOpen,
  setIsRemoveModalOpen,
  handleSubmitRemove,
}) => {
  const closeAndReset = () => {
    setIsRemoveModalOpen(false);
  };

  const handleOnSubmit = () => {
    handleSubmitRemove();
  };

  return (
    <Modal isOpen={isOpen} className={`${blockEl} modal-550 `} toggle={closeAndReset}>
      <Modal.Header toggle={closeAndReset}>
        <span className="no-caps">
          Do you want to remove Auto-Charge dates on selected invoices?
        </span>
      </Modal.Header>
      <Modal.Body />
      <Modal.Footer>
        <Button type="button" color="link" onClick={closeAndReset}>
          No, keep selected dates
        </Button>
        <Button type="submit" color="primary" onClick={() => handleOnSubmit()}>
          Yes, remove Auto-Charge dates
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RemoveAutoChargeModal;
